import { AddressWithCountry } from "@nano-portal/customers"
import { objectKeysToZodEnum } from "@nano-portal/shared"
import { BusinessContactFormVales } from "./contact/businessContactForm.utils"
import { HouseholdContactFormVales } from "./contact/householdContactFormController"

type GetConsumptionPointAddressArgs = {
  householdContactFormValues?: HouseholdContactFormVales
  businessContactFormValues?: BusinessContactFormVales
}

export function getConsumptionPointAddress(args: GetConsumptionPointAddressArgs): AddressWithCountry {
  if (args.householdContactFormValues) {
    return args.householdContactFormValues.deliveryPointAddress
      ? {
          ...args.householdContactFormValues.deliveryPointAddress,
          countryCode: "CZ",
        }
      : {
          city: args.householdContactFormValues.addressCity,
          street: args.householdContactFormValues.addressStreet,
          descriptiveNumber: args.householdContactFormValues.addressDescriptiveNumber,
          orientationNumber: args.householdContactFormValues.addressOrientationNumber,
          postalCode: args.householdContactFormValues.addressPostalCode,
          countryCode: args.householdContactFormValues.addressCountryCode,
        }
  }

  if (args.businessContactFormValues) {
    return args.businessContactFormValues.deliveryPointAddress
      ? {
          ...args.businessContactFormValues.deliveryPointAddress,
          countryCode: "CZ",
        }
      : {
          city: args.businessContactFormValues.addressCity,
          street: args.businessContactFormValues.addressStreet,
          descriptiveNumber: args.businessContactFormValues.addressDescriptiveNumber,
          orientationNumber: args.businessContactFormValues.addressOrientationNumber,
          postalCode: args.businessContactFormValues.addressPostalCode,
          countryCode: args.businessContactFormValues.addressCountryCode,
        }
  }

  throw new Error("Household contact form values nor business contact form values are provided")
}

export const terminationOptions = {
  TERMINATE: "TERMINATE",
  DO_NOT_TERMINATE: "DO_NOT_TERMINATE",
} as const

export type TerminationOption = typeof terminationOptions[keyof typeof terminationOptions]

export function useTerminationFormOptions(): Record<TerminationOption, string> {
  // translations here
  return {
    TERMINATE: "Vypovězte za mě smlouvu",
    DO_NOT_TERMINATE: "Smlouvu si vypovím sám/sama",
  }
}

export const terminationOptionsSchema = objectKeysToZodEnum(terminationOptions)
